import BaseRepository from "../../../lib/itn-ui-kit/services/repositories/base-repository";
import AdditionalExpenseModel from "../../models/additional-expense";

export default class AdditionalExpenseRepository extends BaseRepository {
  static modelClass = AdditionalExpenseModel;
  modelName = "additional-expense";
}
